import { render, staticRenderFns } from "./CalculationCriteria.vue?vue&type=template&id=5fd938bc&scoped=true"
import script from "./CalculationCriteria.vue?vue&type=script&lang=ts"
export * from "./CalculationCriteria.vue?vue&type=script&lang=ts"
import style0 from "./CalculationCriteria.vue?vue&type=style&index=0&id=5fd938bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd938bc",
  null
  
)

export default component.exports